<template>
  <div id="">
    <div class="introduce">
      <p>请注意各项申请及截止时间</p>
      <!-- <p style="color:red">标准展位的展商必填项为：“公司楣板”，共1项。（按展位类型分为“标摊展位”和“升级标摊，豪华升级标摊”两张表，请按实际申请的展位类型填写对应表单）</p>
      <p style="color:red">光地展位的展商必填项为：“光地展位搭建委托书”、“电器设备租赁表”、“设施位置图”和“特装展位责任保险”，共4项</p> -->
    </div>
    <div class="downPdf"><div class="pdfIcon"><img :src="pdfIcon" alt="" width="100%"></div><a class="iconDownText" :href="demoExcel1" style="font-size:14px;"  target="_blank">完整版展商手册下载</a></div>

    <div class="tableWarp">
      <!-- {{userInfo.bthType}} -->
      <div class="tableTtiel">必填表格</div>
      <div class="tableContent">
        <el-table  border :data="btTable" style="width: 100%">
          <el-table-column
            prop="name"
            label="表格名称">
            <template slot-scope="scope">
              <span class="tableBtn" @click="showDetail(scope.row)">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            label="截止日期"
            width="180">
          </el-table-column>

        </el-table>
      </div>

      <div class="tableTtiel">选填表格</div>
      <div class="tableContent">
        <el-table border :data="nbtTable" style="width: 100%">
          <el-table-column
            prop="name"
            label="表格名称">
            <template slot-scope="scope">
              <span class="tableBtn" @click="showDetail(scope.row)">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            label="截止日期"
            width="180">
          </el-table-column>

        </el-table>
      </div>

      <div class="bottomText">
        <p>请展商务必根据栏内的分类，以及相应截止日期，按时填写及递交<span>必填表格</span> ，以免耽误您的参展。</p>
        <p>选填表格请展商按需填写。若对表格内容有疑问，请分别咨询各表格上方的联系单位及联系人。</p>
      </div>
    </div>

    <el-dialog
      :title="currentData.name"
      :visible.sync="dialogVisible"
      width="50%"
     >
      <div class="dialogContent">
        <div style="font-weight:bold;font-size:14px;padding-bottom:20px" v-if="currentData.url !=''">请点击下载<a class="dialogA" :href="currentData.url" style="font-size:14px;"  target="_blank">{{currentData.name}}</a></div>
        <div style="padding:0px 0 6px ;font-size:14px;">联系方式</div>
        <div class="dialogConct" v-html="currentData.tip"></div>
      </div>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>

  </div>
</template>

<script>
import pdfIcon from '@/assets/pdfIcon.png'
import tzbtm from '@/assets/tzbtm.png'

export default {
  name: 'ServiceBooking',
  data: () => ({
    pdfIcon,
    demoExcel1:'./2024中国国际水果展展商手册.pdf',
    userInfo: JSON.parse(localStorage.getItem('userInfo')),
    btTable:[],   //必填
    nbtTable:[],  //不必填
    tzBtTableData:[  //特装必填
      {         
        date: '2024年7月20日',
        name: 'Form4A特装展位搭建委托书',
        url:'./tz/bt/Form4A特装展位搭建委托书.pdf',
        tip:'<div><p>公司名称：上海创隅展览展示有限公司</p><p>联 系 人：王道伟</p><p>手机号码：13601963612</p><p>电子邮件：cyexpo@vip.163.com</p></div>'
      },
      {         
        date: '2024年7月20日',
        name: 'Form4B电器设备租赁表',
        url:'./tz/bt/Form4B电器设备租赁表.pdf',
        tip:'<div><p>公司名称：上海创隅展览展示有限公司</p><p>联 系 人：王道伟</p><p>手机号码：13601963612</p><p>电子邮件：cyexpo@vip.163.com</p></div>'
      },
      {         
        date: '2024年7月20日',
        name: 'Form4D设施位置图',
        url:'./tz/bt/Form4D设施位置图.pdf',
        tip:'<div><p>公司名称：上海创隅展览展示有限公司</p><p>联 系 人：王道伟</p><p>手机号码：13601963612</p><p>电子邮件：cyexpo@vip.163.com</p></div>'
      },
      {         
        date: '2024年7月20日',
        name: 'Form7A搭建商、运营商实名认证',
        url:'./tz/bt/Form7A搭建商、运营商实名认证.pdf',
        tip:'<div><p>上海新国际博览中心有限公司 </p><p>上海浦东新区龙阳路 2345 号</p><p>电话：(86) 21- 28906888</p><p>传真：(86) 21- 28906866</p><p>电邮：info@sniec.net</p><p>网址：www.sniec.net</p></div>'
      },
      {         
        date: '2024年7月20日',
        name: 'Form7B授权委托书',
        url:'./tz/bt/Form7B授权委托书.pdf',
        tip:'<div><p>上海新国际博览中心有限公司 </p><p>上海浦东新区龙阳路 2345 号</p><p>电话：(86) 21- 28906888</p><p>传真：(86) 21- 28906866</p><p>电邮：info@sniec.net</p><p>网址：www.sniec.net</p></div>'
      },
      {         
        date: '2024年7月20日',
        name: 'Form7C运输商安全承诺书',
        url:'./tz/bt/Form7C运输商安全承诺书.pdf',
        tip:'<div><p>上海新国际博览中心有限公司 </p><p>上海浦东新区龙阳路 2345 号</p><p>电话：(86) 21- 28906888</p><p>传真：(86) 21- 28906866</p><p>电邮：info@sniec.net</p><p>网址：www.sniec.net</p></div>'
      },
      {         
        date: '2024年7月20日',
        name: 'Form7D搭建商安全承诺书',
        url:'./tz/bt/Form7D搭建商安全承诺书.pdf',
        tip:'<div><p>上海新国际博览中心有限公司 </p><p>上海浦东新区龙阳路 2345 号</p><p>电话：(86) 21- 28906888</p><p>传真：(86) 21- 28906866</p><p>电邮：info@sniec.net</p><p>网址：www.sniec.net</p></div>'
      },
      {         
        date: '2024年7月20日',
        name: '特装展台施工证办理说明',
        url:'./tz/bt/特装展台施工证办理说明.pdf',
        tip:'<div><p>公司名称：上海创隅展览展示有限公司 </p><p>联 系 人：王道伟</p><p>手机号码：13601963612</p><p>电子邮件：cyexpo@vip.163.com</p></div>'
      },
      {         
        date: '2024年7月20日',
        name: '特装展位责任保险通知',
        url:'./tz/bt/特装展位责任保险通知.pdf',
        tip:'<div><p>会展风险管理网 </p><p>会展风险管理经理</p><p>联系人：李欣 、陈伟君</p><p>电话：(86) 21-51113250、18217731507、18217730796</p></div>'
      },
      {         
        date: '2024年7月15日',
        name: '特装展位搭建审图',
        url:'./tz/bt/关于特装展台搭建审图的通知.pdf',
        tip:'<div><p>安选会展科技（上海）有限公司 </p><p>联系人：葛伟超 先生 /胡伟政 先生</p><p>电话：02169957316/7319</p><p>电邮：CIFE@opt-safe.com</p><p>超链接：<a href="https://ohss.opt-safe.cn/cife2024/" target="_blank">https://ohss.opt-safe.cn/cife2024/</a></p></div>'
      },
      {         
        date: '2024年8月27日',
        name: '关于租赁临时监控及一键报警可视对讲装置的说明 ',
        url:'./tz/bt/关于租赁临时监控及一键报警可视对讲装置的说明.pdf',
        tip:'<div><p ><img src="'+tzbtm+'" width="170px"></p><p style="padding-bottom:10px">微信扫一扫打开进入展会设备租赁小程序</p><p>单位名称：上海几昇信息科技有限公司</p><p>单位联系人：朱欣桐 15000663737</p></div>'
      }
    ],
    tzNbtTableData:[    //特装不必填
      {         
        date: '2024年7月20日',
        name: 'Form4C压缩空气、水源、吊点与宽带租赁表',
        url:'./tz/nbt/Form4C压缩空气、水源、吊点与宽带租赁表.pdf',
        tip:'<div><p>公司名称：上海创隅展览展示有限公司</p><p>联 系 人：王道伟</p><p>手机号码：19921238017</p><p>电子邮件：cyexpo@vip.163.com</p></div>'
      },
      {         
        date: '2024年7月20日',
        name: 'Form5展台助手服务（翻译、司仪）',
        url:'./tz/nbt/Form5展台助手服务（翻译、司仪）.pdf',
        tip:'<div><p>上海外院翻译社</p><p>联系人：王老师</p><p>电话：（86）13818598778</p><p>电子邮件：swfy@foxmail.com</p></div>'
      },
      {         
        date: '2024年7月20日',
        name: 'Form6酒店房间预订单',
        url:'./tz/nbt/Form6酒店房间预订单.pdf',
        tip:'<div><p>上海奥润特会展服务有限公司</p><p>联络人: 黄女士</p><p>电话: (86 21) 51099795</p><p>手机号：13024112752</p><p>电邮: booking@orient-explorer.com.cn</p><p>在线预订连接：</p><p><a href="https://www.orient-explorer.net/CIFE/"  target="_blank">www.orient-explorer.net/CIFE</a></p><p style="padding-top:30px">其他酒店推荐</p><p>陆家嘴明城酒店(上海新国际博览中心店)</p><p>联系人：沈永明</p><p>座机：021-68986666转3301</p><p>手机：13818748050</p><p>邮箱：kimi.shen@ljzsupremetower.com</p><p>陆家嘴明城酒店入住需求意向表：</p><p><a href="https://wj.qq.com/s2/14786136/6loe/"  target="_blank">https://wj.qq.com/s2/14786136/6loe/</a></p></div>'
      },
      {         
        date: '2024年7月20日',
        name: 'Form8A双层、多层或室外展台设计的建筑审批',
        url:'./tz/nbt/Form8A双层、多层或室外展台设计的建筑审批.pdf',
        tip:'<div><p>上海汉海展览咨询有限公司</p><p>上海浦东新区龙阳路2345号E2馆E2-2E1</p><p>邮编：201204</p><p>电话：(86)21-2890-6633/34/35*800</p><p>传真：(86)21-28906000</p><p>电邮：hah@hahchina.com</p><p>联系人：顾倩 女士</p></div>'
      },
      {         
        date: '2024年7月20日',
        name: 'Form8B单层特装展台搭建审批表',
        url:'./tz/nbt/Form8B单层特装展台搭建审批表.pdf',
        tip:'<div><p>上海汉海展览咨询有限公司</p><p>上海浦东新区龙阳路2345号E2馆E2-2E1</p><p>邮编：201204</p><p>电话：(86)21-2890-6633/34/35*800</p><p>传真：(86)21-28906000</p><p>电邮：hah@hahchina.com</p><p>联系人：顾倩 女士</p></div>'
      },
    ],
    btBtTableData:[   //标摊必填
      {         
        date: '2024年7月20日',
        name: 'Form3A公司楣板-标准展位',
        url:'./bt/bt/Form3A公司楣板-标准展位.pdf',
        tip:'<div><p>公司名称：上海创隅展览展示有限公司</p><p>联 系 人：王道伟</p><p>手机号码：19921238017</p><p>电子邮件：cyexpo@vip.163.com</p></div>'
      },
      {         //标摊必填
        date: '2024年7月20日',
        name: 'Form3B公司楣板-豪华升级标摊',
        url:'./bt/bt/Form3B公司楣板-豪华升级标摊.pdf',
        tip:'<div><p>公司名称：上海创隅展览展示有限公司</p><p>联 系 人：王道伟</p><p>手机号码：19921238017</p><p>电子邮件：cyexpo@vip.163.com</p></div>'
      },
    ],
    btNbtTableData:[   //标摊不必填
      {      
        date: '2024年7月20日',
        name: 'Form3C标摊展具租赁表',
        url:'./bt/nbt/Form3C标摊展具租赁表.pdf',
        tip:'<div><p>公司名称：上海创隅展览展示有限公司</p><p>联 系 人：王道伟</p><p>手机号码：19921238017</p><p>电子邮件：cyexpo@vip.163.com</p></div>'
      },
      {      
        date: '2024年7月20日',
        name: 'Form5展台助手服务（翻译、司仪）',
        url:'./bt/nbt/Form5展台助手服务（翻译、司仪）.pdf',
        tip:'<div><p>上海外院翻译社</p><p>联系人：王老师</p><p>电话：（86）13818598778</p><p>电子邮件：swfy@foxmail.com</p></div>'
      },
      {      
        date: '2024年7月20日',
        name: 'Form6酒店房间预订单',
        url:'./bt/nbt/Form6酒店房间预订单.pdf',
        tip:'<div><p>上海奥润特会展服务有限公司</p><p>联络人: 黄女士</p><p>电话: (86 21) 51099795</p><p>手机号：13024112752</p><p>电邮: booking@orient-explorer.com.cn</p><p>在线预订连接：</p><p><a href="https://www.orient-explorer.net/CIFE/"  target="_blank">www.orient-explorer.net/CIFE</a></p><p style="padding-top:30px">其他酒店推荐</p><p>陆家嘴明城酒店(上海新国际博览中心店)</p><p>联系人：沈永明</p><p>座机：021-68986666转3301</p><p>手机：13818748050</p><p>邮箱：kimi.shen@ljzsupremetower.com</p><p>陆家嘴明城酒店入住需求意向表：</p><p><a href="https://wj.qq.com/s2/14786136/6loe/"  target="_blank">https://wj.qq.com/s2/14786136/6loe/</a></p></div>'
      },
      {      
        date: '2024年7月20日',
        name: 'Form7A搭建商、运营商实名认证',
        url:'./bt/nbt/Form7A搭建商、运营商实名认证.pdf',
        tip:'<div><p>上海新国际博览中心有限公司</p><p>上海浦东新区龙阳路 2345 号</p><p>电话：(86) 21- 28906888</p><p>传真：(86) 21- 28906866</p><p>电邮：info@sniec.net</p><p>网址：www.sniec.net</p></div>'
      },
      {      
        date: '2024年7月20日',
        name: 'Form7B授权委托书',
        url:'./bt/nbt/Form7B授权委托书.pdf',
        tip:'<div><p>上海新国际博览中心有限公司</p><p>上海浦东新区龙阳路 2345 号</p><p>电话：(86) 21- 28906888</p><p>传真：(86) 21- 28906866</p><p>电邮：info@sniec.net</p><p>网址：www.sniec.net</p></div>'
      },
      {      
        date: '2024年7月20日',
        name: 'Form7C运输商安全承诺书',
        url:'./bt/nbt/Form7C运输商安全承诺书.pdf',
        tip:'<div><p>上海新国际博览中心有限公司</p><p>上海浦东新区龙阳路 2345 号</p><p>电话：(86) 21- 28906888</p><p>传真：(86) 21- 28906866</p><p>电邮：info@sniec.net</p><p>网址：www.sniec.net</p></div>'
      },
      {      
        date: '2024年7月20日',
        name: 'Form7D搭建商安全承诺书',
        url:'./bt/nbt/Form7D搭建商安全承诺书.pdf',
        tip:'<div><p>上海新国际博览中心有限公司</p><p>上海浦东新区龙阳路 2345 号</p><p>电话：(86) 21- 28906888</p><p>传真：(86) 21- 28906866</p><p>电邮：info@sniec.net</p><p>网址：www.sniec.net</p></div>'
      }
    ],
    currentData:{},
    dialogVisible:false
  }),
  components: {

  },
  mounted() {

    if(this.userInfo.bthType == '特装'){
      this.btTable = this.tzBtTableData
      this.nbtTable = this.tzNbtTableData
    }

    if(this.userInfo.bthType == '标摊'){
      this.btTable = this.btBtTableData
      this.nbtTable = this.btNbtTableData
    }
  },
  methods: {
    showDetail(obj){
      this.currentData = obj
      this.dialogVisible = true
      console.log(obj.name)
    }
  }
}
</script>
<style lang="less" scope>
.introduce{
  font-weight: bold;
  font-size: 14px;
}
.introduce p{
  padding:10px 0
}
.downPdf{
  display: flex;
  align-items: flex-end;
  margin: 20px 0;
}
.downPdf .pdfIcon{
  width: 40px;
}
.downPdf .iconDownText{
  margin-left: 10px;
  font-size: 16px;
}
.tableTtiel{
  font-weight: bold;
  font-size: 16px;
}
.tableContent{
  padding: 20px 0;
}
.bottomText{
  font-size: 14px;
  font-weight: bold;
  margin-top: 20px;
}
.bottomText p{
  padding: 6px;
  // text-align: ;
}
.bottomText span{
  font-size: 20px;
  color: red;
}
.tableBtn{
  font-size: 14px;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
.dialogContent{
  font-weight: bold;
}
.dialogContent .dialogA{
  font-size: 14px;
  color: blue;
  text-decoration: underline;
  margin-left: 10px;
}
.dialogContent .dialogConct{
     line-height: 26px;
     font-size: 14px;
}
</style>
